<template>
  <div class="product-service-section-container">
      <section-title :text="title" :mess="mess"/>
      <div class="section-main">
          <div v-for="data in dataList" :key="data.name" :class="'cls-item'">
              <div class="item-name">{{data.name}}</div>
              <div class="item-content">{{data.describe}}</div>
            </div>
      </div>
  </div>
</template>

<script>
import sectionTitle from "../../components/sectionTitle.vue";
export default {
name: "Advantages",
components: {
  sectionTitle
},
props: {
  title: {
    type: String,
    default: "核心优势"
  },
  mess: {
    type: String,
    default: "多方数据融合，多元生态协同，打造智能化、场景化的数智服务"
  }
},
data() {
  return {
    dataList:[
      {
        name: "数据开放",
        describe:
          "以TEE安全岛为代表的行业领先数据安全技术为保障，开放京东数据，融合品牌全域数据，完善从营销到转化的业务数据链条，助力基于全域视角的科学决策。"
      },
      {
        name: "智能应用",
        describe:
          "基于先进AI模型和全域数据融合计算能力，提供生意经营诊断、增量人群挖掘、营销策略优化、货品趋势洞察等全场景智能服务，以智能技术提升数据应用效率。"
      },
      {
        name: "场景服务",
        describe:
          "基于品牌具体业务目标，聚焦经营增长、用户增长、营销提效、新品创新四大场景，联动全线数智产品与京准通广告产品体系，提供场景解决方案和服务，实现全场景经营与营销闭环。"
      },
      {
        name: "生态共生",
        describe:
          "与行业优秀伙伴携手提供优质服务、共建数智工具，更高效服务品牌客户生意；开放更多数智产品销售渠道，与行业优秀伙伴共拓更广泛商机、助力收入攀升。"
      }
    ]
  }

}
};
</script>

<style lang="scss" scoped>
.product-service-section-container {
  height: 514px;
  width: 100%;
  padding: 80px 0 100px;
  background-size: cover;
  background-position: center center;
  background-image: url('//img10.360buyimg.com/img/jfs/t1/219406/33/49000/14581/673d92eeFa63e94a6/fe1e282f18ebbc66.jpg');

.section-main {
  width: 1225px;
  margin: 28px auto 0;
  display:flex;
  flex-wrap:wrap;
  .cls-item {
    height: 188px;
    border-radius: 12px;
    background-position: center center;
    background-image: url(//img10.360buyimg.com/img/jfs/t1/191764/25/52290/57994/673d9464F0909f233/614955fe1f8adadc.png);
    width: 582px;
    margin: 12px;
    background-size: 630px 245px;
    box-shadow: 1px 5px 24px rgba(144, 153, 209, 0.18);         
    cursor:pointer;
    .cls-img {
      width: 128px;
      height: 107px;
      display: block;
      margin: 0 auto;
    }
    .item-name {
      line-height: 22px;
      font-size: 18px;
      font-weight: 500;
      color: #333;
      margin-left: 50px;
      margin-top: 30px;
    }
    .item-content {
      margin-top: 14px;
      font-size: 14px;
      font-weight: 400;
      color: #666;
      width: 395px;
      margin-left: 50px;
      line-height: 25px;
    }
  }
  .cls-item:hover {
    box-shadow: 1px 5px 24px rgba(144, 153, 209, 0.6);
  }
}
}
</style>

